<div class="consent-banner" *ngIf="showBanner" role="region" aria-label="Cookie consent">
  <div class="consent-inner">
    <p class="consent-text">
      We use cookies to understand how Echo is used so we can improve it. Decline and we
      collect anonymous, cookieless data only.
      <!--
        Points at Echo's own policy rather than solenex.it, which is a
        different site: this one is served by this app, so it cannot drift
        out from under the banner.
      -->
      <a routerLink="/privacy" class="privacy-link">Read our Privacy Policy</a>.
    </p>

    <div class="consent-actions">
      <button type="button" class="btn-consent btn-consent--decline" (click)="declineConsent()">
        Decline
      </button>
      <button type="button" class="btn-consent btn-consent--accept" (click)="acceptConsent()">
        Accept
      </button>
    </div>
  </div>
</div>
